import { pick } from 'ramda';

export default pick([
  'x',
  'y',
  'width',
  'height',
  'preserveAspectRatio',
  'viewBox',
  'zoomAndPan',
]);
